<template>
    <section id="main-slider" class="carousel slide carousel-fade card" data-ride="carousel">
        <ol class="carousel-indicators">
            <li v-for="(slider,index) in sliders" data-target="#main-slider" :data-slide-to="index" :class="{active: (index == 0)? true: false}"></li>
        </ol>
        <div class="carousel-inner">
            <div v-for="(slider,index)  in sliders" :class="{'carousel-item' : true , active: (index == 0)? true: false }">
                <a class="d-block" target="_blank" :href="slider.URL" :title="slider.Alt">
                    <img :src="slider.PicPath" @error="imageLoadOnError" class="d-none d-md-block d-lg-block w-100" :alt="slider.Alt.replace(/\s+/g, '-')" :title="slider.Title.replace(/\s+/g, '-')">
                    <img :src="slider.PicPathTablet" @error="imageLoadOnError" class="d-none d-sm-block d-md-none w-100" :alt="slider.Alt.replace(/\s+/g, '-')" :title="slider.Title.replace(/\s+/g, '-')">
                    <img :src="slider.PicPathMobile" @error="imageLoadOnError" class="d-block d-sm-none w-100" :alt="slider.Alt.replace(/\s+/g, '-')" :title="slider.Title.replace(/\s+/g, '-')">
                </a>
            </div>
            
        </div>
        <a class="carousel-control-prev" href="#main-slider" role="button" data-slide="prev">
            <i class="now-ui-icons arrows-1_minimal-right"></i>
        </a>
        <a class="carousel-control-next" href="#main-slider" data-slide="next">
            <i class="now-ui-icons arrows-1_minimal-left"></i>
        </a>
    </section>
</template>

<script>
    export default {
        computed: {
            sliders: function () {
                return this.$store.getters.readSliders;
            }, 
           
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-slider-image-available.png";
            },
        }
    }
</script>

<style scoped>
    #main-slider {
        height:unset !important;
    }
</style>